import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=613e23e8"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.vue?vue&type=style&index=0&id=613e23e8&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613e23e8')) {
      api.createRecord('613e23e8', component.options)
    } else {
      api.reload('613e23e8', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=613e23e8", function () {
      api.rerender('613e23e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/atoms/Icon.vue"
export default component.exports